import { useMemo } from 'react';
import { getScheduleForDate } from '../utils/scheduleUtils';
import { convertTemplateToTraining } from '../utils/trainingUtils';

/**
 * Hook for managing training mode in Home component
 */
import { EventInstanceStore } from '../../../stores/EventInstanceStore';
import { ScheduleStore } from '../../../stores/ScheduleStore';
import { UserStore } from '../../../stores/UserStore';

export const useHomeTrainingMode = (
  isTrainingMode: boolean,
  trainingIdParam: string | undefined,
  eventInstanceStore: EventInstanceStore,
  scheduleStore: ScheduleStore,
  userStore: UserStore,
  format: (date: Date, formatStr: string) => string
) => {
  const trainingData = useMemo(() => {
    if (!isTrainingMode || !trainingIdParam) {
      return null;
    }

    // First, try to find in instances
    const instance = eventInstanceStore.instances.find(
      (inst) => inst.id === trainingIdParam
    );

    if (instance) {
      const trainingDate: Date = new Date(instance.startTime);

      const schedule = getScheduleForDate(
        trainingDate,
        eventInstanceStore,
        scheduleStore,
        userStore,
        format
      );

      return {
        training: schedule?.timeSlots.find((t) => t.id === trainingIdParam),
        trainingDate,
        currentSchedule: scheduleStore.getScheduleForDate(trainingDate),
      };
    }

    const template = scheduleStore.templates.find(
      (t) => t.id === trainingIdParam
    );
    if (template) {
      const trainingDate: Date = new Date();

      return {
        training: convertTemplateToTraining(template, trainingDate, userStore),
        trainingDate,
        currentSchedule: scheduleStore.getScheduleById(template.scheduleId),
      };
    }

    return {
      training: undefined,
      trainingDate: new Date(),
      currentSchedule: undefined,
    };
  }, [
    isTrainingMode,
    trainingIdParam,
    eventInstanceStore.instances,
    eventInstanceStore.instancesCount,
    scheduleStore.templates,
    userStore,
    format,
  ]);

  return trainingData;
};
